import { useEffect, useState } from "react";

function format(msLeft: number): string {
  if (msLeft <= 0) return "0M";
  const days = Math.floor(msLeft / 86_400_000);
  const hours = Math.floor((msLeft % 86_400_000) / 3_600_000);
  const mins = Math.floor((msLeft % 3_600_000) / 60_000);
  if (days > 0) return `${days}D ${hours}H`;
  if (hours > 0) return `${hours}H ${mins}M`;
  return `${mins}M`;
}

/** 분 단위 카운트다운 텍스트 — 스냅샷/보상 소멸/시즌 마감 공용 (60s tick). */
export function Countdown({ to, className }: { to: string; className?: string }) {
  const target = Date.parse(to);
  const [label, setLabel] = useState(() => format(target - Date.now()));

  useEffect(() => {
    const id = setInterval(() => setLabel(format(target - Date.now())), 60_000);
    return () => clearInterval(id);
  }, [target]);

  if (!Number.isFinite(target)) return null;
  return (
    <time dateTime={to} className={className}>
      {label}
    </time>
  );
}
